{
  "perm": {
    "products__read": "ดูสินค้า",
    "products__write": "เพิ่มและแก้สินค้า",
    "products__publish": "เปิด/ปิดสินค้าบนเว็บ",
    "catalog__read": "ดูแคตตาล็อกการ์ด",
    "catalog__write": "แก้แคตตาล็อกการ์ด หมวด แบรนด์",
    "collections__read": "ดูคอลเลกชัน",
    "collections__write": "แก้คอลเลกชัน",
    "import__run": "นำเข้าสินค้าจากไฟล์",
    "media__write": "เพิ่มรูป",
    "media__delete": "ลบรูป",
    "inventory__read": "ดูสต็อก",
    "inventory__receive": "รับสินค้าเข้า",
    "inventory__adjust": "ปรับสต็อก (ต้องบอกเหตุผล)",
    "inventory__transfer": "ย้ายสต็อกระหว่างร้าน",
    "inventory__count": "นับสต็อก",
    "inventory__count__approve": "อนุมัติส่วนต่างการนับที่มาก",
    "inventory__holds__release": "ปล่อยการ์ดที่จองไว้",
    "inventory__holds__manage": "จองการ์ดเอง",
    "inventory__conflicts__resolve": "ตัดสินการ์ดที่ขายซ้ำ",
    "inventory__live_show__manage": "จัดการไลฟ์ขาย",
    "listings__publish": "ลงขายในมาร์เก็ต (ภายหลัง)",
    "channels__manage": "เชื่อมมาร์เก็ต (ภายหลัง)",
    "orders__read": "ดูออเดอร์",
    "orders__update": "โน้ต แท็ก อีเมลของออเดอร์",
    "orders__fulfill": "เตรียมและส่งออเดอร์",
    "orders__cancel": "ยกเลิกออเดอร์",
    "orders__refund": "คืนเงินออเดอร์",
    "orders__edit": "แก้ที่อยู่หรือสินค้าของออเดอร์",
    "discounts__write": "สร้างโค้ดส่วนลด",
    "payments__read": "ดูการชำระเงิน",
    "payments__confirm": "ยืนยันการโอนเงิน (入金確認)",
    "payments__refund": "อนุมัติคืนเงิน ออกเครดิตร้าน",
    "payments__reconcile": "กระทบยอดเครื่องรูดบัตร",
    "payments__settings": "แก้วิธีรับเงินและค่าธรรมเนียม",
    "pos__sell": "ขายที่เครื่องคิดเงิน",
    "pos__refund": "คืนเงินที่เครื่องคิดเงิน",
    "pos__void": "ยกเลิกการขายที่เครื่อง",
    "pos__returns": "รับคืนของที่เครื่อง",
    "pos__open_drawer": "เปิดลิ้นชักเงิน",
    "pos__discount_over_10": "ลดเกิน 10%",
    "pos__override_price": "เปลี่ยนราคาที่เครื่อง",
    "pos__shift__manage": "เปิด/ปิดกะ",
    "pos__devices__pair": "เชื่อมเครื่องคิดเงิน",
    "pos__hold": "พักการขาย",
    "pos__manual_line": "ขายของที่ไม่มีในระบบ",
    "pos__pay_out": "เอาเงินสดออกจากลิ้นชัก",
    "pos__shift_close_variance": "ปิดกะที่เงินสดไม่ตรง",
    "pos__reports": "ดูรายงานเครื่องคิดเงิน",
    "buylist__accept": "รับซื้อการ์ดจากลูกค้า (買取)",
    "buylist__accept_over_limit": "รับซื้อเกินวงเงิน",
    "consignment__read": "ดูผู้ฝากขายและการ์ดฝากขาย",
    "consignment__manage": "จัดการฝากขายและการเคลียร์ยอด",
    "consignment__intake": "รับของฝากขาย (委託受付)",
    "consignment__price_override": "อนุมัติผู้ฝากลดราคามาก",
    "payouts__create": "จ่ายเงินผู้ฝากขาย",
    "payouts__export_bank": "ดาวน์โหลดไฟล์โอนธนาคาร",
    "kyc__verify": "ตรวจบัตรประจำตัว (本人確認)",
    "kyc__view": "ดูเลขบัตรเต็ม",
    "kobutsu__read": "ดู 古物台帳",
    "kobutsu__export": "ดาวน์โหลด 古物台帳",
    "customers__read": "ดูลูกค้า",
    "customers__write": "แก้ข้อมูลลูกค้า",
    "customers__merge": "รวมลูกค้า",
    "customers__export": "ดาวน์โหลดรายชื่อลูกค้า",
    "tax__read": "ดูรายงานภาษี",
    "tax__taxfree": "ขายปลอดภาษี (ต้องผ่านอบรม)",
    "tax__settings": "แก้การตั้งค่าภาษี",
    "cms__edit": "แก้หน้าเว็บและดีไซน์",
    "cms__publish": "เผยแพร่การแก้ไขเว็บ",
    "settings__write": "แก้การตั้งค่าร้าน",
    "settings__read": "ดูการตั้งค่าร้าน",
    "staff__read": "ดูพนักงาน",
    "staff__manage": "เพิ่มและแก้พนักงาน",
    "staff__roles": "แก้บทบาท",
    "api_keys__manage": "กุญแจสำหรับแอปอื่น",
    "reports__view": "ดูรายงานและต้นทุน",
    "reports__consignment": "ดูรายงานฝากขาย",
    "audit__view": "ดูประวัติการแก้ไข",
    "audit__export": "ดาวน์โหลดประวัติการแก้ไข",
    "inbox__read": "ดูและทำงานในรายการ",
    "inbox__manage": "มอบงานให้คนอื่น",
    "notifications__read": "ดูอีเมลที่ส่ง"
  },
  "area": {
    "products": "สินค้า",
    "catalog": "แคตตาล็อก",
    "collections": "คอลเลกชัน",
    "import": "นำเข้า",
    "media": "รูป",
    "inventory": "สต็อก",
    "listings": "มาร์เก็ต",
    "channels": "มาร์เก็ต",
    "orders": "ออเดอร์",
    "discounts": "ส่วนลด",
    "payments": "การชำระเงิน",
    "pos": "เครื่องคิดเงิน",
    "buylist": "รับซื้อ",
    "consignment": "ฝากขาย",
    "payouts": "จ่ายผู้ฝาก",
    "kyc": "ตรวจบัตร",
    "kobutsu": "古物台帳",
    "customers": "ลูกค้า",
    "tax": "ภาษี",
    "cms": "เว็บ",
    "settings": "ตั้งค่า",
    "staff": "พนักงาน",
    "api_keys": "แอปอื่น",
    "reports": "รายงาน",
    "audit": "ประวัติ",
    "inbox": "งาน",
    "notifications": "อีเมล"
  },
  "list": {
    "title": "พนักงาน",
    "intro": "ทุกคนที่ล็อกอินหลังบ้านหรือเครื่องคิดเงิน เฉพาะเจ้าของร้านแก้หน้านี้ได้",
    "add": "เพิ่มพนักงาน",
    "error": "โหลดรายชื่อพนักงานไม่ได้",
    "empty": "ยังไม่มีพนักงาน",
    "you": "(คุณ)",
    "active": "ใช้งาน",
    "off": "ปิดใช้งาน",
    "locked": "ถูกล็อกเพราะใส่รหัสผิด",
    "role": "บทบาท",
    "shops": "ร้าน",
    "two_step": "ยืนยันตัวตน 2 ขั้น",
    "pin": "PIN เครื่องคิดเงิน",
    "last_login": "ล็อกอินล่าสุด",
    "on": "เปิด",
    "set": "ตั้งแล้ว",
    "not_set": "ยังไม่ตั้ง",
    "never": "ยังไม่เคย",
    "all_shops": "ทุกร้าน",
    "a_shop": "ร้าน",
    "change": "แก้ไข",
    "deactivate": "ปิดใช้งาน",
    "reactivate": "เปิดใช้งานอีกครั้ง",
    "deactivated": "{{name}} ล็อกอินไม่ได้แล้ว",
    "reactivated": "{{name}} ล็อกอินได้อีกครั้ง",
    "reset_two_step": "รีเซ็ตการยืนยัน 2 ขั้น",
    "reset_pin": "รีเซ็ต PIN เครื่องคิดเงิน",
    "invited": "ส่งคำเชิญแล้ว",
    "not_signed_in_yet": "ยังไม่เคยเข้าระบบ",
    "invite_valid": "ลิงก์คำเชิญใช้ได้ถึง",
    "resend_invite": "ส่งคำเชิญอีกครั้ง",
    "invite_resent": "ส่งคำเชิญใหม่ไปที่ {{email}} แล้ว ลิงก์เก่าใช้ไม่ได้แล้ว"
  },
  "form": {
    "add_title": "เพิ่มพนักงาน",
    "add_intro": "จะได้รหัสผ่านชั่วคราว แล้วตั้งรหัสเองตอนล็อกอินครั้งแรก",
    "edit_title": "แก้ไข {{name}}",
    "email": "อีเมล",
    "name": "ชื่อ",
    "role": "บทบาท",
    "own_role": "เปลี่ยนบทบาทของตัวเองไม่ได้",
    "locale": "ภาษาของหลังบ้าน",
    "shops": "ร้านที่ทำงานได้",
    "shops_hint": "ไม่ติ๊ก = ทุกร้าน",
    "save": "บันทึก",
    "add": "เพิ่ม",
    "saved": "บันทึกพนักงานแล้ว",
    "fill_all": "ใส่ชื่อ อีเมลที่ถูกต้อง และบทบาท",
    "created_title": "เพิ่ม {{name}} แล้ว",
    "created_body": "ให้รหัสผ่านชั่วคราวนี้กับเจ้าตัว ({{email}}) เขาจะตั้งรหัสเองตอนล็อกอินครั้งแรก",
    "created_once": "แสดงเฉพาะตอนนี้ ถ้าหาย ให้ออกรหัสใหม่จาก \"แก้ไข\"",
    "created_done": "ให้รหัสแล้ว",
    "add_intro_invite": "เจ้าตัวจะได้อีเมลพร้อมลิงก์ให้ตั้งรหัสผ่านเอง",
    "delivery": "วิธีเข้าระบบครั้งแรก",
    "delivery_email": "ส่งอีเมลคำเชิญ (แนะนำ)",
    "delivery_email_hint": "ลิงก์ภาษาของเจ้าตัวให้ตั้งรหัสผ่านเอง ใช้ได้ครั้งเดียว",
    "delivery_temporary_password": "แสดงรหัสผ่านชั่วคราวที่นี่แทน",
    "delivery_temporary_password_hint": "สำหรับคนที่เปิดอีเมลตอนนี้ไม่ได้ — คุณเป็นคนให้รหัส",
    "invite_done": "เสร็จแล้ว",
    "invite_sent": "ส่งอีเมลคำเชิญไปที่ {{email}} แล้ว เจ้าตัวตั้งรหัสผ่านเองจากลิงก์",
    "invite_valid": "ลิงก์ใช้ได้ครั้งเดียว ถึง",
    "invite_two_step": "หลังตั้งรหัสผ่าน เจ้าตัวจะตั้งการเข้าระบบ 2 ขั้นด้วยแอปในมือถือ",
    "invite_resend_hint": "ลิงก์หายหรือหมดอายุ? ใช้ปุ่ม “ส่งคำเชิญอีกครั้ง” ในรายชื่อพนักงาน"
  },
  "two_step": {
    "title": "รีเซ็ตการยืนยัน 2 ขั้นของ {{name}}?",
    "body": "แอปยืนยันตัวตนจะใช้กับร้านไม่ได้ ต้องตั้งใหม่ตอนล็อกอินครั้งถัดไป",
    "confirm": "รีเซ็ตการยืนยัน 2 ขั้น",
    "done": "รีเซ็ตการยืนยัน 2 ขั้นของ {{name}} แล้ว"
  },
  "locale": {
    "ja": "日本語",
    "th": "ไทย",
    "en": "English",
    "zh-Hant": "繁體中文",
    "zh-Hans": "简体中文"
  },
  "roles": {
    "title": "บทบาทและสิ่งที่ทำได้",
    "intro": "แต่ละคอลัมน์คือบทบาท แต่ละแถวคือสิ่งที่ทำได้ บทบาท 6 แบบของร้านล็อกไว้ — คัดลอกเพื่อสร้างบทบาทของตัวเอง",
    "fixed_hint": "บทบาทล็อก — คัดลอกก่อนถ้าจะเปลี่ยน",
    "fixed": "บทบาทล็อก",
    "error": "โหลดบทบาทไม่ได้",
    "permission": "สิ่งที่ทำได้",
    "people_other": "{{count}} คน",
    "copy": "คัดลอก “{{role}}”",
    "copy_name": "{{role}} (สำเนา)",
    "copy_title": "บทบาทใหม่จาก “{{role}}”",
    "copy_intro": "บทบาทใหม่เริ่มด้วยเครื่องหมายเดียวกัน ตั้งชื่อที่พนักงานเข้าใจ",
    "copy_submit": "สร้างบทบาท",
    "copied": "สร้างบทบาทใหม่แล้ว",
    "new_name": "ชื่อบทบาทใหม่",
    "delete": "ลบ",
    "delete_title": "ลบบทบาท “{{role}}”?",
    "delete_body": "ไม่มีใครใช้บทบาทนี้ จะลบออก",
    "delete_in_use_other": "ยังมี {{count}} คนใช้บทบาทนี้ — เปลี่ยนบทบาทให้เขาก่อน",
    "deleted": "ลบบทบาทแล้ว",
    "cell": "{{role}}: {{permission}}",
    "confirm_add": "ให้ “{{role}}” {{permission}}?",
    "confirm_remove": "เลิกให้ “{{role}}”: {{permission}}?",
    "affects_other": "กระทบ {{count}} คน — คนที่ล็อกอินอยู่จะได้รับการเปลี่ยนแปลงภายใน {{minutes}} นาที ถ้าต้องการให้มีผลทันที ให้เขาออกจากระบบแล้วล็อกอินใหม่",
    "confirm": "เปลี่ยนบทบาท",
    "changed": "เปลี่ยนบทบาทแล้ว",
    "system": {
      "owner": "เจ้าของร้าน",
      "manager": "ผู้จัดการ",
      "staff": "พนักงานร้าน",
      "cashier": "แคชเชียร์",
      "content_editor": "ผู้แก้เนื้อหาเว็บ",
      "consignment_manager": "ผู้ดูแลฝากขาย"
    },
    "editable_hint": "แก้บทบาทของร้านได้ที่นี่ รวมบทบาทเจ้าของร้านด้วย — “กลับค่าเริ่มต้น” คืนบทบาทเป็นแบบตอนเริ่ม ช่องที่มีรูปกุญแจคือสิทธิ์ที่บทบาทเจ้าของร้านต้องมีเสมอ เพื่อไม่ให้ร้านล็อกตัวเองออกจากระบบ",
    "always_kept": "บทบาทเจ้าของร้านต้องมีสิทธิ์นี้เสมอ เพื่อไม่ให้ร้านล็อกตัวเองออกจากระบบ",
    "customized": "ร้านแก้ไขแล้ว",
    "reset": "กลับค่าเริ่มต้น: “{{role}}”",
    "reset_title": "คืน “{{role}}” เป็นแบบตอนเริ่มไหม?",
    "reset_body": "ช่องที่ติ๊กจะกลับเป็นแบบตอนร้านเริ่มใช้ระบบ",
    "reset_confirm": "กลับค่าเริ่มต้น",
    "reset_done": "คืนบทบาทเป็นค่าเริ่มต้นแล้ว"
  },
  "keys": {
    "title": "การเชื่อมต่อกับแอปอื่น",
    "intro": "กุญแจทำให้โปรแกรมอื่นใช้ข้อมูลร้านได้ ให้แต่ละโปรแกรมมีกุญแจของตัวเองเฉพาะสิ่งที่จำเป็น",
    "add": "สร้างกุญแจ",
    "error": "โหลดกุญแจไม่ได้",
    "empty": "ยังไม่มีกุญแจ",
    "empty_body": "สร้างเฉพาะเมื่อโปรแกรมขอ",
    "show_revoked": "แสดงกุญแจที่หยุดแล้ว",
    "state_on": "ใช้งาน",
    "state_paused": "พักไว้ (ผู้สร้างถูกปิดใช้งาน)",
    "state_revoked": "หยุดแล้ว",
    "created_at": "สร้างเมื่อ",
    "last_used": "ใช้ล่าสุด",
    "never": "ยังไม่เคย",
    "expires": "หมดอายุ",
    "revoke": "หยุดกุญแจนี้",
    "revoke_title": "หยุดกุญแจ “{{name}}”?",
    "revoke_body": "โปรแกรมที่ใช้จะหยุดทำงานภายใน 1 นาที ย้อนกลับไม่ได้ — สร้างกุญแจใหม่ถ้าจำเป็น",
    "revoked": "หยุดกุญแจ “{{name}}” แล้ว",
    "add_title": "สร้างกุญแจ",
    "add_intro": "ตั้งชื่อตามโปรแกรมที่ใช้",
    "name": "ชื่อ",
    "expires_optional": "หมดอายุ (ไม่บังคับ)",
    "may": "โปรแกรมทำอะไรได้",
    "create": "สร้างกุญแจ",
    "fill_all": "ใส่ชื่อและติ๊กอย่างน้อย 1 ข้อ",
    "created_title": "สร้างกุญแจ “{{name}}” แล้ว — คัดลอกตอนนี้",
    "created_once": "แสดงครั้งเดียวเท่านั้น ปิดหน้านี้แล้วจะเห็นแค่ตัวอักษรแรก ๆ",
    "created_done": "คัดลอกแล้ว"
  }
}
